import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireTenantAdmin } from '~/utils/guards';

/**
 * Delivery Runs console — tenant admins (and super admins, whom `isTenantAdmin` admits)
 * can see and retry their own subsidiary's deliveries; everyone else is redirected. Every
 * read is subsidiary-scoped by the JWT, and integrations still checks `deliveries:*` per call.
 */
export const Route = createFileRoute('/_authenticated/_tenant/deliveries')({
  beforeLoad: requireTenantAdmin(),
  component: () => <Outlet />,
});
